// Order APIs expose the frozen promo terms separately from checkout previews.
export const orderPromoDetails = order => order?.promoCode ? {
  promoCode: order.promoCode,
  promoDiscountAmount: order.promoDiscountAmount,
  discountType: order.promoDiscountType,
  discountValue: order.promoDiscountValue,
} : null;
